import { ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-confirmation-popup',
  imports: [],
  templateUrl: './confirmation-popup.html',
  styleUrl: './confirmation-popup.scss'
})
export class ConfirmationPopupComponent {
   constructor(
    private dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data:
     {
        title:string,
        description:string,
        buttonTitle:string,
      }
   ) {}

  close(isSuccess: boolean = false) {
    this.dialogRef.close(isSuccess);
  }

    @HostListener('document:keydown.escape', ['$event'])
    onEscKeydown(event: any): void {
      event.stopPropagation();
      this.close();
    }
}
